import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import ShareModal from "./ShareModal";
import { encodeListParam } from "../utilities/listParam";

export const ShareButton = ({ mode = "perfil", userId, noteId, listId }) => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [isModalHidden, setIsModalHidden] = useState(true);
  const [modalMessage, setModalMessage] = useState("");

  const copyToClipboard = async () => {
    if (!user) {
      setModalMessage("Debes iniciar sesión para compartir la lista.");
      setIsModalHidden(false);
      return;
    }

    setIsLoading(true);
    const shareableLink = getShareableLink();
    try {
      await navigator.clipboard.writeText(shareableLink);
      setModalMessage("Enlace copiado al portapapeles.");
    } catch (err) {
      setModalMessage("Error al copiar enlace.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleShare = () => {
    if (!user) {
      setModalMessage("Debes iniciar sesión para compartir la lista.");
      setIsModalHidden(false);
      return;
    }

    setIsLoading(true);
    const shareableLink = getShareableLink();

    if (navigator.share) {
      navigator.share({
        title: "NoStateNode",
        text: "Mira mi lista de recursos en NoStateNode",
        url: shareableLink,
      })
        .then(() => setIsLoading(false))
        .catch((error) => {
          console.log("Error sharing", error);
          setIsLoading(false);
        });
    } else {
      setModalMessage("Web Share API no soportada. Usa las opciones de abajo.");
      setIsModalHidden(false);
      setIsLoading(false);
    }
  };

  const getShareableLink = () => {
    const ownerId = userId || user?.uid || '';
    if (mode === "lista" && listId) {
      return `${window.location.origin}/shared/${ownerId}/list/${encodeListParam(listId)}`;
    }
    return `${window.location.origin}/shared/${ownerId}`;
  }

  return (
    <>
      <button
        type="button"
        className="share-btn task-btn"
        onClick={handleShare}
        disabled={isLoading}
      >
        {isLoading
          ? "Compartiendo..."
          : mode === "perfil"
            ? "Compartir perfil"
            : "Compartir lista"}
      </button>
      <ShareModal
        isHidden={isModalHidden}
        onClose={() => setIsModalHidden(true)}
        modalTitle={modalMessage}
        copyToClipboard={copyToClipboard}
        yourLink={getShareableLink()}
      />
    </>
  );
};

export default ShareButton;